import { useEffect, useState } from "react";
import { useChildAgesGate } from "./useChildAgesGate";
import { useStaysUpsellEligibility } from "./useStaysUpsellEligibility";
import { useUpSellTracking } from "./useUpSellTracking";
import { UpSellChoice } from "@/tracking/upSellEmit";

export const useStaysUpsell = () => {
  const { variant, variants, isEnabled, flightUpSellData } =
    useStaysUpsellEligibility();

  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const childAgesGate = useChildAgesGate(flightUpSellData?.handleAddStayClick);

  const showsEntryPoint =
    isEnabled &&
    (variant === variants.sticky_bar || variant === variants.interstitial);
  const { trackTapped, trackModalViewed, trackModalCta } =
    useUpSellTracking(showsEntryPoint);

  useEffect(() => {
    if (isEnabled && variant === variants.interstitial) {
      setIsDialogOpen(true);
    }
  }, [isEnabled, variant, variants.interstitial]);

  useEffect(() => {
    if (isDialogOpen) {
      trackModalViewed();
    }
  }, [isDialogOpen, trackModalViewed]);

  const handleConfirm = () => {
    trackModalCta(UpSellChoice.add_hotel);
    setIsDialogOpen(false);
    childAgesGate.trigger();
  };

  const handleDecline = () => {
    trackModalCta(UpSellChoice.no_thanks);
    setIsDialogOpen(false);
  };

  const handleDismiss = () => {
    trackModalCta(UpSellChoice.dismissed);
    setIsDialogOpen(false);
  };

  return {
    variant,
    variants,
    isEnabled,
    isDialogOpen,
    childAgesGate,
    openDialog: () => {
      trackTapped();
      setIsDialogOpen(true);
    },
    handleConfirm,
    handleDecline,
    handleDismiss,
  };
};
